import axios, {AxiosResponse} from 'axios'
import {AuthModel, UserModel} from './_models'

/**
 * Low-level auth HTTP calls against the Google-auth bridge.
 *
 * `REACT_APP_API_URL` points at the `/api/google` surface of the authorization
 * service, which exchanges a Google OAuth credential for a Davinci session and
 * verifies existing tokens.
 *
 * @module app/modules/auth/core/_requests
 */
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api/google"

/** Endpoint that resolves a {@link UserModel} from a session token. */
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
/** Endpoint that exchanges a Google credential for an {@link AuthModel}. */
export const LOGIN_URL = `${API_URL}/login`

/**
 * Exchange a Google OAuth credential for a Davinci session.
 *
 * @param token  The Google credential (ID token) from the OAuth flow.
 * @returns The axios response carrying the {@link AuthModel}.
 */
export function login(token: string): Promise<AxiosResponse<AuthModel>> {
    return axios.post<AuthModel>(LOGIN_URL, {
        token,
        //password,
    })
}

/**
 * Resolve the current {@link UserModel} from a stored credential/token.
 *
 * @param token  The persisted session credential.
 * @returns The axios response carrying the {@link UserModel}.
 */
export function getUserByToken(token: string): Promise<AxiosResponse<UserModel>> {
    const userModel = axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
        token: token,
    });

    console.log(userModel);
    return userModel;
}
